import { getApiErrorHttpStatus } from '@mi-front/core';
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry on 404 errors
        if (getApiErrorHttpStatus(error) === 404) {
          return false;
        }
        // Retry other errors up to 3 times
        return failureCount < 3;
      },
    },
  },
});
